import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import IconSprite from "./components/IconSprite";
import "./styles.css";
import "./theme.css";

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <IconSprite />
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
